import request from '@/config/axios'

export interface O2oHomeBannerVO {
  id?: number
  title?: string
  subtitle?: string
  /** CTA 按钮文案 */
  ctaText?: string
  /** 信任标 JSON 数组字符串 */
  trustBadges?: string
  imageUrl?: string
  /** NONE / SERVICE / CATEGORY / H5 */
  linkType?: string
  /** 服务 ID / 品类 ID / H5 URL */
  linkTarget?: string
  /** 空 = 全国 */
  cityCode?: string
  sort?: number
  status?: number
  createTime?: Date
}

export const O2oHomeBannerApi = {
  getPage: async (params: any) => {
    return await request.get({ url: '/o2o/marketing/banner/page', params })
  },
  get: async (id: number) => {
    return await request.get({ url: '/o2o/marketing/banner/get?id=' + id })
  },
  create: async (data: O2oHomeBannerVO) => {
    return await request.post({ url: '/o2o/marketing/banner/create', data })
  },
  update: async (data: O2oHomeBannerVO) => {
    return await request.put({ url: '/o2o/marketing/banner/update', data })
  },
  updateStatus: async (data: { id: number; status: number }) => {
    return await request.put({ url: '/o2o/marketing/banner/update-status', data })
  },
  delete: async (id: number) => {
    return await request.delete({ url: '/o2o/marketing/banner/delete?id=' + id })
  }
}
